export const useScrollTo = () => {
  const scrollToElementWithId = (idElement: string) => {
    document.getElementById(idElement)?.scrollIntoView({ behavior: 'smooth' })
  }

  return {
    scrollToElementWithId
  }
}
